module.exports = __webpack_public_path__ + "static/media/triangle-exclamationi.49f4f618.svg";